<template>
  <v-container grid-list-md>
    <v-layout row wrap>

      <v-flex sm12
              xs12
              md12
              lg12>
        <material-stats-card :color="storeTitleColor"
                             icon="mdi-book-open-page-variant"
                             title=""
                             :value="$t('documents.download.seminar_download')"
                             sub-text="Just Updated">

          

          <v-flex xs11 lg11 slot="items_slot_cutom">
            <v-list class="text-right">
              <v-icon color="success" dark style="font-size: 25px !important;">check</v-icon>
              {{ $t('documents.download.file_exists') }}
              <v-icon color="error" dark style="font-size: 25px !important;">close</v-icon>
              {{ $t('documents.download.file_does_not_exist') }}
            </v-list>
            <br/>

            <v-list two-line subheader dense>
              <v-list-tile v-for="item in popisUsluga"
                           :key="item.Ime"
                           avatar
                           @click="preuzmiFile(item)"
                           class="v-list__tile--link-border-custom">
                <!--<v-list-tile-avatar>
        <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
      </v-list-tile-avatar>-->

                <v-list-tile-content>
                  <v-list-tile-title>{{ item.Ime }}</v-list-tile-title>
                  <!--<v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>-->

                </v-list-tile-content>

                <v-list-tile-avatar>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }" v-if="item.FilePostoji == true">
                      <v-icon color="success" dark v-on="on" style="font-size: 25px !important;">check</v-icon>
                    </template>
                    <template v-slot:activator="{ on }" v-else>
                      <v-icon color="error" dark v-on="on" style="font-size: 25px !important;">close</v-icon>
                    </template>

                    <span v-if="item.FilePostoji">{{ $t('documents.download.tooltip') }}</span>
                    <span v-else>{{ $t('documents.download.seminar_download_not_found') }}</span>
                  </v-tooltip>


                </v-list-tile-avatar>

              </v-list-tile>
            </v-list>

          </v-flex>
        </material-stats-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>
  export default {
    name: 'SeminarDownload',
    props: {
      loadingFunction: {
        type: Function
      },
      storeTitleColor: ''
    },

    mounted() {
      this.getUslugeZaSeminar();
    },

    methods: {
      async getUslugeZaSeminar() {
        this.loadingFunction(true);

        var result = await this.$fetchDataPromise('/api/Documents/GetUslugeZaSeminarskiZadatak', null).catch(x => { this.loadingFunction(false); this.$displayError(x); });
        this.popisUsluga = result.map(x => {
          x.icon = 'info';
          x.iconClass = 'blue lighten-1 white--text';
          return x;
        });

        this.loadingFunction(false);
      },

      async preuzmiFile(item) {
        this.loadingFunction(true);

        var data = { UpisPO_ID: item.UpisPO_ID, Naziv: item.Naziv }
        var result = await this.$fetchDataPromise('/api/Documents/DownloadSeminarskiZadatak', data).catch(x => { this.loadingFunction(false); this.$displayError(x) });

        if (typeof result != 'undefined') {
          this.$downloadByteArray([result.fileBytes], result.fileExtension, result.fileName);
          this.loadingFunction(false);
          this.$displaySuccess(this.$t('documents.download.download_success'));
        }
      },

    },

    data() {
      return {
        popisUsluga: [],
        items: [
          { icon: 'assignment', iconClass: 'blue lighten-1 white--text', title: 'Photos', subtitle: 'Jan 9, 2014' },
          { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Recipes', subtitle: 'Jan 17, 2014' },
          { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Work', subtitle: 'Jan 28, 2014' },
        ]

      }
    }



  }
</script>



// WEBPACK FOOTER //
// VueSrc/SeminarTask/components/SeminarDownload.vue